import React, { useState } from "react";
import FormFieldSet from "../../FormFields/FormFieldSet";
import CkTextEditor from "../../CkTextEditor/CkTextEditor";
import FileUploadNew from "../../FormFields/FileUploadNew";
import Button from "../../Buttons/Button";
import Drawer from "../../Modal/Drawer";
import useFormHandler from "../../Validations/useFormHandler";
import { addTicketApi } from "../../../redux/slices/tickets/ticketApi";
import { showToast } from "../../Toast/Toast";
import { useLoginUser } from "../../../hooks/useLoginUser";

const RaiseATicketDrawer = ({ isOpen, onClose }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const initialFormData = {
    ticketName: "",
    module: "",
    priority: "",
    subject: "",
    description: "",
    department: "",
  };

  // Validation rules
  const validationRules = {
    ticketName: { required: true, minLength: 3 },
    module: { required: true },
    priority: { required: true },
    subject: { required: true, minLength: 5 },
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);

  const handleSubmit = async () => {
    if (!validateAllFields()) {
      showToast("Please fill all required fields correctly", "error");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        ticketTitle: formData.ticketName,
        ticketSubject: formData.subject,
        module: formData.module,
        customerName: loginUserData?.organizationId?.uiid,
        priority: formData.priority,
        description: formData.description || null,
        department: formData.department,
        addedBy: loginUserUiid,
        status: "Open",
        organizationId: loginUserData?.organizationId?.uiid,
      };
      const response = await addTicketApi({
        coll: "Ticket",
        payload: payload,
      });

      // // Handle file uploads separately if needed
      // if (selectedFiles.length > 0 && response?.data?.ticketId) {
      //   // You'll need a separate API endpoint to handle file uploads
      //   // await uploadTicketAttachments(response.data.ticketId, selectedFiles);
      //   console.log("Files to upload:", selectedFiles);
      // }
      if (response?.success) {
        showToast("Ticket raised successfully!", "success");
        setFormData(initialFormData);
        setSelectedFiles([]);
        onClose();
      }
    } catch (error) {
      console.error("Error creating ticket:", error);
      showToast("Failed to create ticket", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setFormData(initialFormData);
    setSelectedFiles([]);
    onClose();
  };

  return (
    <div>
      <Drawer
        isOpen={isOpen}
        onClose={handleClose}
        width="max-w-4xl md:max-w-2xl"
        title="Raise a Ticket"
        titleColor="primary"
      >
        <div className="flex flex-col gap-5">
          <div className="grid grid-cols-2 gap-4">
            <FormFieldSet
              title="Ticket name"
              type="text"
              placeholder="Enter"
              value={formData.ticketName}
              onChange={(val) => handleChange("ticketName", val)}
              error={errors.ticketName}
              required
            />

            <FormFieldSet
              title="Module"
              type="select"
              placeholder="Select"
              required
              options={[
                { label: "ATS", value: "1" },
                { label: "Workforce", value: "2" },
              ]}
              value={formData.module}
              onChange={(value) => handleChange("module", value)}
              error={errors.module}
            />
            <FormFieldSet
              title="Department"
              type="select"
              placeholder="Select"
              required
              options={[
                { label: "Billing", value: "1" },
                { label: "IT Support", value: "2" },
              ]}
              value={formData.department}
              onChange={(value) => handleChange("department", value)}
              error={errors.department}
            />

            <FormFieldSet
              title="Priority"
              type="select"
              placeholder="Select"
              required
              options={[
                { label: "High", value: "High" },
                { label: "Medium", value: "Medium" },
                { label: "Low", value: "Low" },
              ]}
              value={formData.priority}
              onChange={(value) => handleChange("priority", value)}
              error={errors.priority}
            />
          </div>

          <FormFieldSet
            title="Subject"
            type="text"
            placeholder="Enter"
            value={formData.subject}
            onChange={(val) => handleChange("subject", val)}
            required
            error={errors.subject}
          />
          <div>
            <span>Description</span>
            <CkTextEditor
              value={formData.description}
              onChange={(val) => handleChange("description", val)}
            />
          </div>
          {/* <FormFieldSet
              type="file"
              title={"Attachment"}
              placeholder="Choose File"
            /> */}
          <FileUploadNew
            title="Add Attachment"
            color="info"
            accept="all"
            onChange={(files) => setSelectedFiles(files)}
            multiple
          />
          {/* {selectedFiles.map((file) => (
            <p>{file.name}</p>
          ))} */}
          <div className="flex justify-end gap-4">
            <Button
              title="Cancel"
              variant="outlined"
              onClick={handleClose}
              disabled={isSubmitting}
            />
            <Button
              title={isSubmitting ? "Submitting..." : "Submit"}
              onClick={handleSubmit}
              disabled={isSubmitting}
            />
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default RaiseATicketDrawer;
